import { ConvexError } from "convex/values";

// A Convex refusal carries the server's reason in `data` ({ code, message },
// or a plain string); its `message` is the client's call trace
// ("[CONVEX M(...)] [Request ID: ...]"). Anything else shows `fallback` when
// the caller gives one (a sentence naming what failed), else its own message.
export function refusalReason(err: unknown, fallback?: string): string {
  if (err instanceof ConvexError) {
    const data: unknown = err.data;
    if (typeof data === "string" && data) return data;
    const message = (data as { message?: unknown } | null)?.message;
    if (typeof message === "string" && message) return message;
  }
  if (fallback !== undefined) return fallback;
  return err instanceof Error && err.message ? err.message : "unknown error";
}
